import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Cart.css";

export default function Cart() {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);

  // Load cart
  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem("cart")) || []);
  }, []);

  // Update quantity
  const updateQty = (index, delta) => {
    const updated = [...cart];
    updated[index].qty += delta;
    if (updated[index].qty < 1) updated[index].qty = 1;

    setCart(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  // Total price
  const total = cart.reduce(
    (sum, item) => sum + item.price * item.qty,
    0
  );

  // ✅ FIX: total item count (qty sum)
  const totalItems = cart.reduce(
    (sum, item) => sum + item.qty,
    0
  );

  return (
    <div className="container py-5">
      {/* CONTINUE SHOPPING */}
      <Link
        to="/"
        className="text-decoration-none text-muted mb-3 d-inline-block"
      >
        ← Continue Shopping
      </Link>

      <h2 className="cart-title">Shopping Cart</h2>

      <div className="row">
        {/* LEFT SIDE */}
        <div className="col-lg-9">
          {cart.length === 0 ? (
            <p>Your cart is empty</p>
          ) : (
            cart.map((item, i) => (
              <div key={i} className="cart-item">
                {/* TOP */}
                <div className="cart-item-top">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="cart-img"
                  />

                  <div>
                    <div className="product-name">
                      {item.title}
                    </div>
                    <div className="product-meta">
                      Price: ₹{item.price}
                    </div>
                  </div>
                </div>

                {/* PRICE + QTY */}
                <div className="cart-price">
                  <div className="qty-box">
                    <button onClick={() => updateQty(i, -1)}>−</button>
                    <input value={item.qty} readOnly />
                    <button onClick={() => updateQty(i, 1)}>+</button>
                  </div>

                  <div className="item-total">
                    ₹{item.price * item.qty}
                  </div>
                </div>
              </div>
            ))
          )}

          {/* SUBTOTAL */}
          <div className="cart-subtotal">
            <span>Subtotal</span>
            <span>₹{total}</span>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-3 mt-4 mt-lg-0">
          <div className="order-summary">
            <h6>
              Order Details
              {/* ✅ FIXED HERE */}
              <span>{totalItems} item</span>
            </h6>

            <div className="order-total">
              <span>Total</span>
              <span>₹{total}</span>
            </div>

          <button
  className="checkout-btn"
  disabled={cart.length === 0}
  onClick={() => navigate("/checkout")}
>
  Checkout
</button>

          <button
  className="quote-btn"
  disabled={cart.length === 0}
  onClick={() => {
    localStorage.setItem(
      "rfqCart",
      JSON.stringify({
        items: cart,
        total,
        totalItems
      })
    );
    navigate("/requestquote");
  }}
>
  Request Quote
</button>


            <p className="save-cart-text">
              <Link
                to="/signin"
                className="text-decoration-none text-white"
              >
                Sign in
              </Link>{" "}
              to save this cart or email it
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
